import React, { FC } from 'react';
import { Plus } from '@phosphor-icons/react';
import { FormStepNode } from '../workoutBuilderTypes';
import { useConditioningSteps } from './useConditioningSteps';
import { STEP_PRESETS_BY_SLUG } from './stepPresets';
import StepSingleRow from './StepSingleRow';
import StepGroupCard from './StepGroupCard';
import styles from './ConditioningSteps.module.scss';

interface ConditioningStepsEditorProps {
  steps: FormStepNode[];
  onChange: (s: FormStepNode[]) => void;
  /** Atleta di anteprima per la conversione %→assoluto (BUG E). Opzionale. */
  previewAthleteId?: string;
  /** Slug del mezzo: mostra i preset-scorciatoia (distanze/RSA) (BUG B). */
  exerciseSlug?: string;
}

const ConditioningStepsEditor: FC<ConditioningStepsEditorProps> = ({
  steps,
  onChange,
  previewAthleteId,
  exerciseSlug,
}) => {
  const presets = exerciseSlug ? STEP_PRESETS_BY_SLUG[exerciseSlug] : undefined;
  const {
    addSingle,
    addGroup,
    removeNode,
    updateNode,
    addChild,
    removeChild,
    updateChild,
  } = useConditioningSteps(steps, onChange);

  return (
    <div className={styles.container}>
      <div className={styles.editorHeader}>
        <span className={styles.editorTitle}>Costruisci la seduta a step</span>
      </div>

      {presets && presets.length > 0 && (
        <div className={styles.presetRow}>
          <span className={styles.presetLabel}>Preset</span>
          {presets.map((p) => (
            <button
              key={p.label}
              type="button"
              className={styles.presetChip}
              onClick={() => onChange([...steps, p.build()])}
            >
              {p.label}
            </button>
          ))}
        </div>
      )}

      {steps.length === 0 ? (
        <div className={styles.emptyHint}>
          Aggiungi tratti singoli o una ripetuta (gruppo ×N)
        </div>
      ) : (
        <div className={styles.stepsList}>
          {steps.map((node) => {
            if (node.kind === 'group') {
              return (
                <StepGroupCard
                  key={node._localId}
                  node={node}
                  previewAthleteId={previewAthleteId}
                  onChange={(patch) => updateNode(node._localId, patch)}
                  onRemove={() => removeNode(node._localId)}
                  onAddChild={() => addChild(node._localId)}
                  onRemoveChild={(childId) => removeChild(node._localId, childId)}
                  onUpdateChild={(childId, patch) =>
                    updateChild(node._localId, childId, patch)
                  }
                />
              );
            }
            return (
              <StepSingleRow
                key={node._localId}
                node={node}
                previewAthleteId={previewAthleteId}
                onChange={(patch) => updateNode(node._localId, patch)}
                onRemove={() => removeNode(node._localId)}
              />
            );
          })}
        </div>
      )}

      <div className={styles.addButtonsRow}>
        <button
          type="button"
          className={styles.addBtn}
          onClick={addSingle}
        >
          <Plus size={13} weight="bold" />
          <span>Aggiungi tratto</span>
        </button>
        <button
          type="button"
          className={styles.addBtnGroup}
          onClick={addGroup}
        >
          <Plus size={13} weight="bold" />
          <span>Aggiungi ripetuta (gruppo ×N)</span>
        </button>
      </div>
    </div>
  );
};

export default ConditioningStepsEditor;
